// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const TOPICS_DESCRIPTOR = msg({
	message: 'Topics',
	comment:
		'Title of the list of feed categories (Football, Valorant, Music...) beside or above the feed; each opens the public posts filed under it. Keep it concise.',
});

export const FEED_INTERESTS_DESCRIPTOR = msg({
	message: 'Feed interests',
	comment:
		'Settings section title for the feed topics the user picked as interests, which Discover shows more of. Keep it concise.',
});
